import { BrowserRouter, Route, Router, Routes } from 'react-router-dom';
import "./assets/index.css"

import SearchPage from './components/Search.jsx';
import Home from './components/Home.jsx';
import CreditPresumidPage from './components/CreditPresumidPage.jsx';

function App() {
  return (
    <BrowserRouter>
      <div className='bg-secondary h-screen'>
        <Routes>
          <Route index path='/' element={<Home />} />
          <Route index path='/classificacao-tributaria' element={<SearchPage />} />
          <Route index path='/credito-presumido' element={<CreditPresumidPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
